/* Mayfly Studios - keep hero videos playing.
 *
 * Browsers refuse autoplay outright when a video is not muted, and Safari also
 * pauses playback under Low Power Mode, on data saver, and when a page is
 * restored from the back/forward cache. The initial play() therefore cannot be
 * assumed to have succeeded, so re-assert it on the events that follow a
 * refusal.
 *
 * A video that is already playing is never touched, so a visitor who has
 * unmuted the hero will not have it silently re-muted.
 */
(function () {
  if (typeof window === 'undefined') return;

  function videos() {
    return document.querySelectorAll('video[autoplay], video[data-mf-autoplay]');
  }

  function nudge(v) {
    if (!v || v.tagName !== 'VIDEO') return;
    if (!v.paused && !v.ended) return; // already running - leave it alone

    // Muted is the price of autoplay; without it the request is denied.
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');

    var p = v.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () { /* blocked for now; a later trigger retries */ });
    }
  }

  function nudgeAll() {
    var list = videos();
    for (var i = 0; i < list.length; i++) nudge(list[i]);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  ready(function () {
    nudgeAll();

    // Media events fire per-element and do not bubble, so capture them.
    var mediaEvents = ['loadeddata', 'canplay', 'canplaythrough', 'suspend', 'pause'];
    for (var i = 0; i < mediaEvents.length; i++) {
      document.addEventListener(mediaEvents[i], function (e) {
        if (e.target && e.target.tagName === 'VIDEO') nudge(e.target);
      }, true);
    }

    // The first real interaction lifts most autoplay restrictions.
    var gestures = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
    for (var g = 0; g < gestures.length; g++) {
      window.addEventListener(gestures[g], nudgeAll, { once: true, passive: true });
    }

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) nudgeAll();
    });
    window.addEventListener('pageshow', nudgeAll);

    if (window.MutationObserver) {
      var pending;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(nudgeAll, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }
  });
})();
